import styles from './style.module.scss';
function SpecialitiesGraphWidget() {
    return (
        <div className={styles.bodyLoader}>
            <span className={styles.loader}></span>
        </div>
    );
}

export default SpecialitiesGraphWidget;
